import { Injectable } from '@angular/core';
import { AppConfig } from '../../common/app.config';
import { UvExplorerClient } from '../../common/UvExplorerClient';
import { Observable, Subject } from 'rxjs/Rx';
import { LicenseInfoDto, LicenseWizardRequestDto, LicenseWizardResultDto, SoftwareInfoDto } from 'UvExplorerServer.Dtos.TS/LicenseStats';

@Injectable()
export class LicensingWebService {
	constructor(private appConfig: AppConfig, private uvExplorerClient: UvExplorerClient) {
		return;
	}

	public testPrtgService(): Observable<any> {
		let url = `https://uvxserver.acme.com:9945/api/config/userimages`;
		let subject = new Subject<any>();

		let resourceUrl = `https://uvxserver.acme.com:9945/api/config/userimages`;
		fetch(resourceUrl, { mode: 'cors' })
			.then((response) => {
				response.json()
					.then((json) => {
						subject.next(json);
					})
					.catch((error) => {
						console.error(error);
						subject.error(error);
					});
			})
			.catch((error) => {
				console.error(error);
				subject.error(error);
			});

		//this.uvExplorerClient.get<any>(url).subscribe(
		//	(result: any) => {
		//		subject.next(result);
		//	},
		//	(error) => {
		//		console.error(error);
		//		subject.error(error);
		//	});

		return subject.asObservable();
	}

	public getLicenseInfo(): Observable<LicenseInfoDto> {
		let url = this.appConfig.sessionServiceUrl + `api/session/licenseinfo`;
		let subject = new Subject<LicenseInfoDto>();

		this.uvExplorerClient.get<LicenseInfoDto>(url).subscribe(
			(result: LicenseInfoDto) => {
				subject.next(result);
			},
			(error) => {
				console.error(error);
				subject.error(error);
			});

		return subject.asObservable();
	}

	public getSoftwareInfo(): Observable<SoftwareInfoDto> {
		let url = this.appConfig.sessionServiceUrl + `api/session/softwareupdateinfo`;
		let subject = new Subject<SoftwareInfoDto>();

		this.uvExplorerClient.get<SoftwareInfoDto>(url).subscribe(
			(result: SoftwareInfoDto) => {
				//console.log("Update: " + result);
				subject.next(result);
			},
			(error) => {
				console.error(error);
				subject.error(error);
			});

		return subject.asObservable();
	}

	public licenseActivationWizard(request: LicenseWizardRequestDto): Observable<LicenseWizardResultDto> {
		let url = this.appConfig.sessionServiceUrl + `api/session/licenseactivationwizard`;
		let subject = new Subject<LicenseWizardResultDto>();

		let body = JSON.stringify(request);

		this.uvExplorerClient.post<LicenseWizardResultDto>(url, body).subscribe(
			(result: LicenseWizardResultDto) => {
				subject.next(result);
			},
			(error) => {
				console.error(error);
				subject.error(error);
			});

		return subject.asObservable();
	}

	public licenseDeactivationWizard(request: LicenseWizardRequestDto): Observable<LicenseWizardResultDto> {
		let url = this.appConfig.sessionServiceUrl + `api/session/licensedeactivationwizard`;
		let subject = new Subject<LicenseWizardResultDto>();

		let body = JSON.stringify(request);

		this.uvExplorerClient.post<LicenseWizardResultDto>(url, body).subscribe(
			(result: LicenseWizardResultDto) => {
				subject.next(result);
			},
			(error) => {
				console.error(error);
				subject.error(error);
			});

		return subject.asObservable();
	}

	public licenseUpdateWizard(request: LicenseWizardRequestDto): Observable<LicenseWizardResultDto> {
		let url = this.appConfig.sessionServiceUrl + `api/session/licenseupdatewizard`;
		let subject = new Subject<LicenseWizardResultDto>();

		let body = JSON.stringify(request);

		this.uvExplorerClient.post<LicenseWizardResultDto>(url, body).subscribe(
			(result: LicenseWizardResultDto) => {
				subject.next(result);
			},
			(error) => {
				console.error(error);
				subject.error(error);
			});

		return subject.asObservable();
	}

}